var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelephone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "telephone_3_",
    "data-name": "telephone (3)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.999,
    height: 20,
    viewBox: "0 0 19.999 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M19.5,14.751l-2.486-2.486a1.76,1.76,0,0,0-2.486,0l-1.13,1.13a1.334,1.334,0,0,1-1.883,0l-4.9-4.9a1.331,1.331,0,0,1,0-1.884l1.13-1.13a1.757,1.757,0,0,0,0-2.487L5.255.514a1.76,1.76,0,0,0-2.484,0l-.906.9a6.347,6.347,0,0,0,0,8.966l7.761,7.765a6.336,6.336,0,0,0,8.966,0l.9-.9A1.76,1.76,0,0,0,19.5,14.751ZM3.6,1.343a.587.587,0,0,1,.829,0L6.912,3.821a.586.586,0,0,1,0,.829L6.5,5.065,3.185,1.752Zm6.857,15.97L2.693,9.547A5.152,5.152,0,0,1,2.37,2.594l3.3,3.3a2.5,2.5,0,0,0,.109,3.424l4.9,4.9h0a2.5,2.5,0,0,0,3.424.109l3.3,3.3A5.142,5.142,0,0,1,10.455,17.313Zm8.212-.9-.414.414-3.315-3.315.414-.414a.587.587,0,0,1,.829,0l2.486,2.486A.587.587,0,0,1,18.667,16.409Z",
    transform: "translate(-0.011 0)",
    fill: "#cbcbcb"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.6a751dfcfe64971afa3cb666890af2fa.svg";
export { ForwardRef as ReactComponent };